import React from 'react'
import t from '../../../i18n/translations/translations'
import HartuFacilityCard from '../HartuFacilityCard/HartuFacilityCard'
import CardGrid from '../../../atoms/CardGrid/CardGrid'
import './HartuFacilityGrid.css'

function HartuFacilityGrid({ data, lang, selectedDate, isLoading }) {
    let content

    if (data?.length) {
        content = data.map((card) => 
        (
            <HartuFacilityCard
                card={card}
                censed={card.censed}
                description={card.description}
                disability={card.disability}
                image={card.image}
                idFacility={card.id}
                lang={lang}
                idinstancia={card.idinstancia}
                selectedDate={selectedDate}
                canBookButton={card.can_book_button}
                hasDiscount={card.has_discount}
                maxBookingsDay={card.max_bookings_day}
                maxBookingsMonth={card.max_bookings_month}
                limitBookingsDayReached={card.limit_bookings_day_reached}
                limitBookingsMonthReached={card.limit_bookings_month_reached}
                limitInstance={card.limit_instance}
                limitInstanceName={card.limit_instance_name}
            />
        ))
    } else if (isLoading) {
        content = (
            <div className="hartuFacilityGrid__message">
                <p>{t.loading[lang]}</p>
            </div>
        )
    } else {
        content = (
            <div className="hartuFacilityGrid__message">
                <p>{t.no_facilities_found[lang]}</p>
            </div>
        )
    }

    return <CardGrid className="hartuFacilityGrid">{content}</CardGrid>
}

export default HartuFacilityGrid
